import React, { useState } from "react";

import Modal from 'react-bootstrap/Modal';


function RestictionUpdate(props) {

  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  return (
    <>
  <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title></Modal.Title>
    </Modal.Header>
    <Modal.Body>Este sitio que forma parte del proyecto LatamChequea vacunas fue actualizado por última vez en <b>abril de 2022</b>.<br />
      Si querés ver las notas sobre coronavirus realizadas por medios de LatamChequea -que incluyen las notas sobre vacunas- podés entrar en el especial de LatamChequea coronavirus que seguimos actualizando <a href="https://chequeado.com/latamcoronavirus/" target="_blank">acá</a>.</Modal.Body>
    <Modal.Footer>
    </Modal.Footer>
  </Modal>
  </>
  );
}

export default RestictionUpdate;
